import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-logout',
  template: ``,
  styles: [],
  imports: [],
  standalone: true,
})
/**
 * Helper component that performs local session cleanup after the Entra logout redirect.
 * Clears the MSAL cache and redirects the user to the main application page,
 * which will trigger a new login flow.
 */
export class LogoutComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly msalService = inject(MsalService);

  ngOnInit(): void {
    this.msalService.instance.clearCache().then(() => {
      // Redirect to the main application
      void this.router.navigate(['/lead-pool']);
    }).catch((error) => {
      console.error('Error during logout cleanup:', error);
      // Even if there's an error, redirect to main page
      void this.router.navigate(['/lead-pool']);
    });
  }
}

